import { type InstallationQuotationStatus } from "@repo/api";
import { FilterCheckbox, translateInstallationQuotationStatus } from "@repo/ui";
import { hasItems, isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const installationQuotationStatusList: InstallationQuotationStatus[] = [
  "DRAFT",
  "SENT",
  "ACCEPTED",
  "VOIDED",
  "NOTSIGNED",
];

export const InstallationQuotationStatusFilter = ({
  actions,
  filters,
}: FilterItemsProps) => {
  return (
    <FilterListContainer id="installation-quotation-status-filter">
      {hasItems(installationQuotationStatusList) &&
        installationQuotationStatusList.map((key) => (
          <FilterCheckbox
            key={key}
            id={key}
            value={key}
            label={translateInstallationQuotationStatus(key) ?? "-"}
            checked={isChecked(filters.installationQuotationStatus, key)}
            onCheckFilter={actions.setInstallationQuotationStatus}
          />
        ))}
    </FilterListContainer>
  );
};
